"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _commonReact = require("@devsta/common-react");

var _EditScriptRoot = _interopRequireDefault(require("../components/EditScriptRoot"));

var _api = require("../api");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function EditScript(_ref) {
  var history = _ref.history,
      id = _ref.match.params.id;
  return _react.default.createElement(_commonReact.CollaborationProvider, {
    resourceId: id,
    resourceName: "Script"
  }, _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      getScript: (0, _api.getScriptApi)(id),
      updateScript: (0, _api.updateScriptApi)(id),
      getOrganisation: (0, _api.getOrganisationApi)()
    }
  }, function (_ref2) {
    var getScript = _ref2.getScript,
        updateScript = _ref2.updateScript,
        getOrganisation = _ref2.getOrganisation;
    return _react.default.createElement(_commonReact.CollaborationConsumer, null, function (_ref3) {
      var fetchCollaborationData = _ref3.fetchCollaborationData;
      return _react.default.createElement(_EditScriptRoot.default, {
        history: history,
        getScript: getScript,
        updateScript: updateScript,
        getOrganisation: getOrganisation,
        fetchCollaborationData: fetchCollaborationData
      });
    });
  }));
}

var _default = (0, _withBasedRouter.default)(_basePath.default, EditScript);

exports.default = _default;